module.exports = __webpack_public_path__ + "media/images/icons/credit-card-af03f4973fb902c4d90ff54ad4bdd6f4.svg";